import http from '@/http'

const API_PATH = 'room_option_masters/'

const state = {
  roomOptionMasters: []
}

const getters = {
  roomOptionMasters: state => state.roomOptionMasters
}

const mutations = {
  roomOptionMasters(state, payload) {
    state.roomOptionMasters = payload
  }
}

const actions = {
  async index({ commit }) {
    await http.get(API_PATH).then(response => {
      commit('roomOptionMasters', response.data.data.map(roomOptionMaster => roomOptionMaster.attributes))
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
